"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const paramsFormatter_1 = (0, tslib_1.__importDefault)(require("../paramsFormatter"));
exports.default = {
    dryRunTransaction: {
        method: 'dry_run_transaction',
        paramsFormatters: [paramsFormatter_1.default.toRawTransaction],
    },
    calculateDaoMaximumWithdraw: {
        method: 'calculate_dao_maximum_withdraw',
        paramsFormatters: [paramsFormatter_1.default.toOutPoint, paramsFormatter_1.default.toHash],
    },
};
//# sourceMappingURL=experimental.js.map